document.addEventListener("DOMContentLoaded", function () {
  // Function to handle logout
  function handleLogout() {
    localStorage.removeItem("customer_hash"); // Remove session ID from local storage
    window.location.href = "/account/login"; // Redirect to login page
  }

  // Attach logout functionality to the logout button
  const logoutButton = document.querySelector("#logout-btn1");
  if (logoutButton) {
    logoutButton.addEventListener("click", function (event) {
      event.preventDefault();
      handleLogout();
    });
  }

  // Function to show content based on the page parameter
  function showContent(page) {
    const allContentElements = document.querySelectorAll(".club-content > div");
    allContentElements.forEach((element) => element.classList.remove("show"));

    const clubContentElement = document.querySelector(".club-content");
    clubContentElement.classList.remove("nobackground");

    const contentElement = document.getElementById(page);
    if (contentElement) contentElement.classList.add("show");
  }

  // Function to set the selected class to the clicked menu item
  function setSelected(selectedItem) {
    const menuItems = document.querySelectorAll(".club-nav_item");
    menuItems.forEach((menuItem) => menuItem.classList.remove("selected"));
    selectedItem.classList.add("selected");
  }

  // Initialize navigation functionality
  function initializeNavigation() {
    const menuItems = document.querySelectorAll(".club-nav_item");

    const pageMapping = {
      "go-to-prehled": "prehled",
      "go-to-objednavky": "objednavky",
      "go-to-vyhody": "vyhody",
      "go-to-slevy": "slevy",
      "go-to-udaje": "udaje",
      "go-to-heslo": "heslo",
      "go-to-informace": "informace",
    };

    menuItems.forEach((menuItem) => {
      menuItem.addEventListener("click", function (event) {
        event.preventDefault();
        const itemId = event.target.id;
        const page = pageMapping[itemId];
        const newUrl = `${window.location.pathname}?page=${page}`;
        window.history.pushState({ path: newUrl }, "", newUrl);
        showContent(page);
        setSelected(menuItem);
      });
    });

    // On page load, check URL parameter and display corresponding content
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get("page");
    if (page) {
      const initialMenuItem = document.querySelector(`.club-nav_item[id="go-to-${page}"]`);
      if (initialMenuItem) {
        showContent(page);
        setSelected(initialMenuItem);
      }
    }
  }

  // Function to fetch and render user data
  async function fetchAndRenderUserData() {
  const customer_hash = localStorage.getItem("customer_hash"); // Get session ID from local storage

    if (!customer_hash) {
      window.location.href = "/account/login"; // Redirect to login page if session ID is missing
      return;
    }
  
    try {
      const response = await fetch("/a/api/club/customer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customer: customer_hash }),
      });
  
      const data = await response.json();
      console.log(data);
  
      // Check if the response contains the expected fields
      if (data && data.first_name && data.last_name && data.email) {
        const {
          first_name,
          last_name,
          email,
          orders,
          giftcards,
          club_points,
          club_level_info,
        } = data;
  
        // Update user information
        updateUserInfo({ first_name, last_name, email });
  
        // Update club points and level
        updateClubInfo(club_points, club_level_info);
  
        // Render orders
        if (orders && Array.isArray(orders)) {
          renderOrders(orders);
        }
  
        // Render gift cards
        if (giftcards && Array.isArray(giftcards)) {
          renderGiftCards(giftcards);
        }
      } else {
        console.warn("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error in API request:", error);
    }
  }

  // Function to update user information in the DOM
  function updateUserInfo({ first_name, last_name, email }) {
    updateElements(".data-first-name", first_name);
    updateElements(".data-last-name", last_name);
    updateElements(".data-email", email);
  }

  // Function to update club points and level in the DOM
  function updateClubInfo(club_points, club_level_info) {
    updateElements(".data-club_points", club_points);

    if (club_level_info) {
      const levelPointsMax = club_level_info.level_points_max + 1;
      updateElements(".data-level_points_max", levelPointsMax);

      const clubPointsLeft = levelPointsMax - club_points;
      updateElements(".data-club_points_left", clubPointsLeft);

      const percentValue = (club_points / levelPointsMax) * 100;
      document.querySelectorAll(".data-level_points_percent").forEach((element) => {
        element.style.width = `${percentValue}%`;
      });

      const clubLevelName = getClubLevelName(club_level_info.level_id);
      updateElements(".data-clubLevel_name", clubLevelName);

      if (club_level_info.level_benefits && Array.isArray(club_level_info.level_benefits)) {
        club_level_info.level_benefits.forEach((benefit) => {
            document.querySelectorAll(`.${benefit}`).forEach((element) => {
                element.style.display = "flex";
            });
        });
      }

    }
  }

  // Function to get the club level name based on level_id
  function getClubLevelName(level_id) {
    switch (level_id) {
      case "bronze":
        return "Bronzový začátek";
      case "silver":
        return "Stříbrný úspěch";
      case "gold":
        return "Zlatá cílová rovinka";
      case "blue":
        return "Botasová modrá";
      case "vip":
        return "VIP";
      default:
        return "";
    }
  }

  // Function to render orders
  function renderOrders(orders) {
    const orderListContainers = document.querySelectorAll(".data-orderList");

    orders.forEach((order) => {
      const orderItem = document.createElement("div");
      orderItem.classList.add("order-item");

      const orderItemInfo = document.createElement("div");
      orderItemInfo.classList.add("order-item-info", "flex-row");

      const itemPicture = document.createElement("div");
      itemPicture.classList.add("item-picture", "r-break--three");
      const orderImage = document.createElement("img");
      orderImage.classList.add("data-orderItem-order_image");
      orderImage.src = order.image;
      itemPicture.appendChild(orderImage);
      orderItemInfo.appendChild(itemPicture);

      const itemInformation = document.createElement("div");
      itemInformation.classList.add("item-information", "flex-row");

      const labelsColumn = document.createElement("div");
      labelsColumn.classList.add("flex-column", "r-break--two");
      labelsColumn.innerHTML = `
        <span class="info-title">Objednáno</span>
        <span class="info-title">Objednávka</span>
        <span class="info-title">Cena</span>
        <span class="info-title" style="display: none">Stav</span>
      `;

      const valuesColumn = document.createElement("div");
      valuesColumn.classList.add("flex-column");
      valuesColumn.innerHTML = `
        <span class="info-content data-orderItem-order_date">${order.date || ""}</span>
        <span class="info-content data-orderItem-order_name">#${order.name || ""}</span>
        <span class="info-content data-orderItem-order_value">${order.value || ""}</span>
      `;

      const orderStatusElement = document.createElement("span");
      orderStatusElement.classList.add("info-content", "data-orderItem-order_status");
      orderStatusElement.textContent = getOrderStatusText(order.order_status);
      if (order.order_status) {
        orderStatusElement.classList.add(`status-${order.order_status}`);
      }
      valuesColumn.appendChild(orderStatusElement);

      itemInformation.appendChild(labelsColumn);
      itemInformation.appendChild(valuesColumn);
      orderItemInfo.appendChild(itemInformation);
      orderItem.appendChild(orderItemInfo);

      orderListContainers.forEach((container) => container.appendChild(orderItem));
    });
  }

  // Function to get the translated order status text
  function getOrderStatusText(status) {
    switch (status) {
      case "received":
        return "Přijatá";
      case "paid":
        return "Zaplacená";
      case "completed":
        return "Dokončená";
      default:
        return status || "";
    }
  }

  // Function to render gift cards
  function renderGiftCards(giftcards) {
    const couponListContainers = document.querySelectorAll(".data-couponList");

    giftcards.forEach((giftcard) => {
      const couponItem = document.createElement("div");
      couponItem.classList.add("coupon", "flex-row");

      const couponInfo = document.createElement("div");
      couponInfo.classList.add("coupon-info", "flex-column");
      couponInfo.innerHTML = `
        <span class="club-h5-ease b-break--one data-coupon_name">${giftcard.note || ""}</span>
        <span class="club-h3 data-coupon_code">${giftcard.code || ""}</span>
      `;

      const couponDesign = document.createElement("div");
      couponDesign.classList.add("coupon-design");
      const couponImage = document.createElement("img");
      couponImage.src = "https://cdn.shopify.com/s/files/1/0823/9038/4983/files/barcode.svg?v=1723040795";
      couponDesign.appendChild(couponImage);

      couponItem.appendChild(couponInfo);
      couponItem.appendChild(couponDesign);

      couponListContainers.forEach((container) => container.appendChild(couponItem));
    });
  }

  // Function to update multiple elements with the same class
  function updateElements(selector, value) {
    if (value !== undefined) {
      document.querySelectorAll(selector).forEach((element) => {
        element.textContent = value;
        if (element.tagName === "INPUT") element.value = value;
      });
    }
  }

  // Function to show error messages
  function showError(message) {
    const errorMessage = document.createElement("div");
    errorMessage.textContent = message;
    errorMessage.classList.add("error-message");
    document.querySelector(".club-content").appendChild(errorMessage);
  }

  // Initialize the script
  initializeNavigation();
  fetchAndRenderUserData();
});